import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  ReviewProjectMutation as ReviewProjectMutationType,
  ReviewProjectMutationVariables,
} from "./__generated__/ReviewProjectMutation";

const ReviewProjectMutation = loader("./ReviewProjectMutation.gql");

type ReviewProjectMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: ReviewProjectMutationType) => void;
}) => ReactElement;

export const ReviewProjectMutationProvider: ReviewProjectMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<ReviewProjectMutationType, ReviewProjectMutationVariables>(
    ReviewProjectMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
      refetchQueries: ["AbilitiesQuery"],
      awaitRefetchQueries: true,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
